import React, { useEffect, useState } from 'react'
import { Button, Table, Form as frm } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Select from 'react-select'
import { useImmer } from 'use-immer'
import AddInExistingIcon from '../../../components/AllSvgIcon/AddInExistingIcon'
import Loader from '../../../components/Loader'
import CustomToast from '../../../components/Toast/CustomToast'
import {
  calculatePageRange,
  encodeId,
  showToast
} from '../../../lib/AllGlobalFunction'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import {
  isInventoryModel,
  isSellerPanel,
  pageRangeDisplayed
} from '../../../lib/AllStaticVariables'
import axiosProvider from '../../../lib/AxiosProvider'
import { _productImg_ } from '../../../lib/ImagePath'
import { _exception } from '../../../lib/exceptionMessage'
import { setPageTitle } from '../../redux/slice/pageTitleSlice'

const ExistingProductList = () => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const { userInfo, pageAccess, sellerDetails } = useSelector(
    (state) => state.user
  )
  const [allState, setAllState] = useImmer({
    sellerDetails: [],
    category: [],
    brand: []
  })
  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })
  const [filterDetails, setFilterDetails] = useImmer({
    pageSize: 50,
    pageIndex: 1,
    searchText: '',
    sellerId: isInventoryModel
      ? sellerDetails?.id
        ? sellerDetails?.id
        : userInfo?.userId
      : ''
  })

  const fetchExtraData = async (id) => {
    try {
      if (!allState?.sellerDetails?.length && !isInventoryModel) {
        const sellerDetails = await axiosProvider({
          method: 'GET',
          endpoint: 'SellerData/bindActiveSeller',
          queryString: `?pageindex=0&PageSize=0`
        })

        if (sellerDetails?.status === 200) {
          setAllState((draft) => {
            draft.sellerDetails = sellerDetails?.data?.data
          })
        }
      }

      if (isSellerPanel || isInventoryModel) {
        const sellerBrand = await axiosProvider({
          method: 'GET',
          endpoint: 'AssignBrandToSeller/bySeller&BrandId',
          queryString: `?sellerId=${
            isSellerPanel ? userInfo?.userId : sellerDetails?.userID
          }&pageIndex=0&pageSize=0&status=Active`
        })

        if (sellerBrand?.status === 200) {
          setAllState((draft) => {
            draft.sellerBrand = sellerBrand?.data?.data
          })
        }
      } else {
        if (!allState?.brand?.length) {
          const brand = await axiosProvider({
            method: 'GET',
            endpoint: 'Brand/search',
            queryString: `?pageindex=0&PageSize=0&status=Active`
          })

          if (brand?.status === 200) {
            setAllState((draft) => {
              draft.brand = brand?.data?.data
            })
          }
        }
      }

      if (!allState?.brand?.length) {
        const brand = await axiosProvider({
          method: 'GET',
          endpoint: 'Brand/search',
          queryString: `?pageindex=0&PageSize=0&status=Active`
        })

        if (brand?.status === 200) {
          setAllState((draft) => {
            draft.brand = brand?.data?.data
          })
        }
      }

      if (!allState?.category?.length) {
        const category = await axiosProvider({
          method: 'GET',
          endpoint: 'MainCategory/getEndCategory',
          queryString: `?pageIndex=0&pageSize=0`
        })

        if (category?.status === 200) {
          setAllState((draft) => {
            draft.category = category?.data?.data
          })
        }
      }

      if (id) {
        const assignedBrand = await axiosProvider({
          method: 'GET',
          endpoint: 'AssignBrandToSeller/bySeller&BrandId',
          queryString: `?sellerId=${id}&pageIndex=0&pageSize=0&status=Active`
        })

        if (assignedBrand?.status === 200) {
          setAllState((draft) => {
            draft.sellerBrand = assignedBrand?.data?.data
          })
        }
      }
    } catch {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  const handleFetchData = async (values) => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'GET',
        endpoint: 'AddInExistingProduct/getProductlist',
        queryString: `?sellerId=${values?.sellerId ?? 0}&brandId=${
          values?.brandId ?? 0
        }&categoryID=${values?.categoryId ?? 0}&productSKUCode=${
          values?.skuCode ?? ''
        }&pageIndex=${values?.pageIndex}&pageSize=${values?.pageSize}`
      })
      setLoading(false)

      if (response?.status === 200) {
        setAllState((draft) => {
          draft.productList = response?.data
        })
      }
    } catch {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  useEffect(() => {
    dispatch(setPageTitle('Add Existing Product'))

    fetchExtraData()
  }, [])

  return (
    <>
      <div className='card'>
        <div className='card-body'>
          <div className='row'>
            {!isInventoryModel && (
              <div className='input-file-wrapper col-md-3'>
                <label className='form-label required'>Select Seller</label>
                <Select
                  id='sellerDetails'
                  name='sellerDetails'
                  value={
                    filterDetails?.sellerId && {
                      label: filterDetails?.sellerName,
                      value: filterDetails?.sellerId
                    }
                  }
                  placeholder='Select Seller'
                  options={
                    allState?.sellerDetails &&
                    allState?.sellerDetails?.map(({ userId, displayName }) => ({
                      label: displayName,
                      value: userId
                    }))
                  }
                  onChange={(e) => {
                    setFilterDetails((draft) => {
                      draft.sellerId = e?.value ?? null
                      draft.sellerName = e?.label ?? ''
                      draft.brandId = null
                      draft.brandName = ''
                      draft.errors = {
                        ...filterDetails?.errors,
                        sellerId: '',
                        brandId: ''
                      }
                    })
                  }}
                />
                {filterDetails?.errors?.sellerId && (
                  <span className='text-danger'>
                    {filterDetails?.errors?.sellerId}
                  </span>
                )}
              </div>
            )}

            <div
              className={`input-file-wrapper col-md-${
                isInventoryModel ? '4' : '3'
              }`}
            >
              <label className={`form-label ${isInventoryModel && 'required'}`}>
                Select Brand
              </label>
              <Select
                name='brandId'
                id='brandId'
                isClearable
                value={
                  filterDetails?.brandId && {
                    label: filterDetails?.brandName,
                    value: filterDetails?.brandId
                  }
                }
                placeholder='Select Brand'
                options={
                  allState?.sellerBrand
                    ? allState?.sellerBrand?.map(({ brandId, brandName }) => ({
                        label: brandName,
                        value: brandId
                      }))
                    : allState?.brand?.map(({ id, name }) => ({
                        value: id,
                        label: name
                      }))
                }
                onChange={(e) => {
                  setFilterDetails((draft) => {
                    draft.brandId = e?.value ?? null
                    draft.brandName = e?.label ?? ''
                    draft.errors = { ...filterDetails.errors, brandId: '' }
                  })
                }}
              />
              {filterDetails?.errors?.brandId && (
                <span className='text-danger'>
                  {filterDetails?.errors?.brandId}
                </span>
              )}
            </div>

            <div
              className={`input-file-wrapper col-md-${
                isInventoryModel ? '4' : '3'
              }`}
            >
              <label className='form-label'>Select Category</label>
              <Select
                name='categoryId'
                id='categoryId'
                isClearable
                placeholder='Select Category'
                options={
                  allState?.category &&
                  allState?.category?.map(({ id, pathNames, name }) => ({
                    value: id,
                    label: pathNames,
                    categoryName: name
                  }))
                }
                onChange={(e) => {
                  setFilterDetails((draft) => {
                    draft.categoryId = e?.value ?? null
                    draft.categoryName = e?.label ?? ''
                  })
                }}
              />
            </div>

            <div
              className={`input-file-wrapper col-md-${
                isInventoryModel ? '4' : '3'
              }`}
            >
              <label className='form-label'>Search SKU code</label>
              <frm.Control
                control='input'
                type='text'
                name='skuCode'
                value={filterDetails?.skuCode}
                placeholder='SKU Code'
                onChange={(e) => {
                  setFilterDetails((draft) => {
                    draft.skuCode = e?.target?.value
                  })
                }}
              />
            </div>

            <div className='col-md-12 d-flex justify-content-end gap-4 w-auto align-items-center mt-3 ms-auto'>
              <Button
                variant='primary'
                className='fw-semibold mt-3'
                onClick={() => {
                  let filterData = filterDetails
                  if (!filterData?.sellerId) {
                    filterData = {
                      ...filterData,
                      errors: {
                        ...filterData?.errors,
                        sellerId: 'Please select seller'
                      }
                    }
                  } else if (isInventoryModel && !filterData?.brandId) {
                    filterData = {
                      ...filterData,
                      errors: {
                        ...filterData?.errors,
                        brandId: 'Please select brand'
                      }
                    }
                  } else {
                    filterData = {
                      ...filterData,
                      errors: {
                        ...filterData?.errors,
                        brandId: '',
                        sellerId: ''
                      }
                    }
                    setFilterDetails(filterData)
                    handleFetchData(filterData)
                  }
                }}
              >
                Search
              </Button>

              <div className='w-auto d-flex align-items-center mt-3'>
                <label className='me-1'>Show</label>
                <select
                  name='dataget'
                  className='form-select'
                  value={filterDetails?.pageSize}
                  onChange={(e) => {
                    let filterDetailsData = {
                      ...filterDetails,
                      pageSize: e?.target?.value,
                      pageIndex: 1
                    }
                    setFilterDetails((draft) => {
                      draft.pageSize = e?.target?.value
                      draft.pageIndex = 1
                    })
                    if (filterDetails?.sellerId)
                      handleFetchData(filterDetailsData)
                  }}
                >
                  <option value='10'>10</option>
                  <option value='25'>25</option>
                  <option value='50'>50</option>
                  <option value='100'>100</option>
                  <option value='200'>200</option>
                  <option value='500'>500</option>
                </select>
              </div>

              <div className='page-range'>
                {calculatePageRange({
                  ...filterDetails,
                  recordCount:
                    allState?.productList?.data?.data?.pagination
                      ?.recordCount ?? 0
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Table responsive className='align-middle table-list'>
        <thead>
          <tr>
            <th>Product Detail</th>
            <th>Brand</th>
            <th>Category</th>
            <th>Color</th>
            <th>Size</th>
            {checkPageAccess(
              pageAccess,
              allPages?.addInExisting,
              allCrudNames?.update
            ) && <th className='text-center'>Action</th>}
          </tr>
        </thead>
        {allState?.productList?.data?.length > 0 ? (
          <tbody>
            {allState?.productList?.data?.map((data) => (
              <tr
                className='position-relative'
                key={Math.floor(Math.random() * 10000000)}
              >
                <td>
                  <div className='d-flex gap-3 align-items-center'>
                    <img
                      style={{ width: '50px' }}
                      className='img-thumbnail'
                      src={`${process.env.REACT_APP_IMG_URL}${_productImg_}${data?.productImage}`}
                      alt='...'
                    />
                    <div>
                      <p className='pv-font-hard mb-1'>{data?.productName}</p>
                      <div>
                        <span className='pv-font-hard'> SKU Code :</span>{' '}
                        <span>{data?.companySKUCode}</span>
                      </div>
                    </div>
                  </div>
                </td>
                <td>{data?.brandName}</td>
                <td>{data?.categoryPathName}</td>
                <td>{data?.color}</td>
                <td>{data?.size}</td>
                {checkPageAccess(
                  pageAccess,
                  allPages?.addInExisting,
                  allCrudNames?.add
                ) && (
                  <td className='text-center'>
                    <div className='d-flex gap-2 justify-content-center'>
                      {checkPageAccess(
                        pageAccess,
                        allPages?.addInExisting,
                        allCrudNames?.add
                      ) && (
                        <Link
                          className='dropdown-item'
                          to={`/existing-product-form/${encodeId(
                            data?.productID
                          )}`}
                        >
                          <AddInExistingIcon />
                        </Link>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        ) : (
          <tr className='position-relative'>
            <td colSpan={6} className='text-center'>
              No records found
            </td>
          </tr>
        )}
      </Table>

      {allState?.productList?.pagination?.pageCount && (
        <ReactPaginate
          className='list-inline m-cst--pagination d-flex justify-content-end gap-1'
          breakLabel='...'
          nextLabel=''
          onPageChange={(event) => {
            let filterDetailsData = {
              ...filterDetails,
              pageIndex: event.selected + 1
            }
            setFilterDetails((draft) => {
              draft.pageIndex = event.selected + 1
            })
            if (filterDetails?.sellerId) handleFetchData(filterDetailsData)
          }}
          pageRangeDisplayed={pageRangeDisplayed}
          pageCount={allState?.productList?.pagination?.pageCount ?? 0}
          previousLabel=''
          renderOnZeroPageCount={null}
          forcePage={filterDetails?.pageIndex - 1}
        />
      )}

      {toast?.show && (
        <CustomToast text={toast?.text} variation={toast?.variation} />
      )}

      {loading && <Loader />}
    </>
  )
}

export default ExistingProductList
